'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmailMetadata = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _attachmentTypes = require('../constants/attachmentTypes');

var _getAttachments = require('./getAttachments');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEmailMetadata = exports.getEmailMetadata = function getEmailMetadata(commonMessage) {
  var emailMetaData = (0, _getAttachments.getAttachments)(commonMessage).find(function (attachmentObject) {
    return (0, _get2.default)(_messageTypes.MESSAGE_TYPE_ID, attachmentObject) === _attachmentTypes.EMAIL_METADATA;
  });
  return emailMetaData;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/operators/getEmailMetadata.js
// module id = 698
// module chunks = 2 3